import { createRouter, createWebHistory } from 'vue-router'


const routes = [
    {
        path: '/login',
        name: 'login',
        component: ()=> import('@/pages/Login')
    },
    {
        path: '/bj/:fz/:bj',
        name: 'shareclass',
        component: ()=> import('@/pages/ShareClassRoom')
    },
    {
        path: '/',
        redirect: { name: 'home' }
    },
    {
        path: '/web/core/',
        redirect: { name: 'home' },
        component: ()=> import('@/pages/Admin/Index'),
        children: [
            {
                path: 'home',
                name: 'home',
                meta: {auth: true},
                component: ()=> import('@/pages/Admin/Home')
            },
        ]
    }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
